import React from 'react'
import Tooltip from '@retracedgmbh/ui-components-lib/Tooltip'
import Button from '@retracedgmbh/ui-components-lib/Button'
import Box from '@retracedgmbh/ui-components-lib/Box'
import Typography from '@retracedgmbh/ui-components-lib/Typography'
import useTranslator from '@hooks/useTranslator'
import useToast from '@/hooks/useToast'
import {Text, Caption} from '@retracedgmbh/ui-components-lib'

const ErrorToast = ({t, error}) => {
  const {toast} = useToast()
  const {getTranslation} = useTranslator({page: 'components'})
  const errorId = error?.reqId

  const copyErrorId = () => {
    navigator.clipboard
      .writeText(errorId)
      .then(() => {
        toast.success(getTranslation('components.errorToast.errorIdCopied'))
      })
      .catch(error => {
        toast.error(getTranslation('components.errorToast.errorIdNotCopied'))
      })
  }

  return (
    <>
      <Text as={'p'} className="tw:text-content-destructive">
        {error?.message || getTranslation('components.errorToast.somethingWentWrong')}
      </Text>
      <Box flex align="center">
        {errorId && (
          <Caption  className="tw:text-content-destructive">
            {getTranslation('components.errorToast.errorId')} {errorId}
          </Caption>
        )}

        <Tooltip title={getTranslation('components.errorToast.copyErrorId.tooltip')}>
          <Button icon="fa-light fa-copy" onClick={copyErrorId} />
        </Tooltip>
      </Box>
    </>
  )
}

export default ErrorToast
